import { Badge } from '@/shared/components/ui/badge';
import { cn } from '@/shared/lib/utils';

/**
 * 품절 · 신규 필터링 금지 배지 — Badge & Chip Error / strong / Small (Figma 검색_결과 833:6047 · 검색_결과_상세 833:7127)
 * 대조약 · 생동인정은 배지가 아니라 메타 줄 글자로 들어간다 (DrugMeta).
 */
export const DrugBadges = ({
  outOfStock,
  newDrugBanned,
  className,
}: {
  outOfStock?: boolean;
  newDrugBanned?: boolean;
  className?: string;
}) => {
  if (!outOfStock && !newDrugBanned) return null;
  return (
    <span className={cn('flex flex-wrap gap-1', className)}>
      {newDrugBanned && (
        <Badge state="error" emphasis="strong" size="small">
          신규 필터링 금지
        </Badge>
      )}
      {outOfStock && (
        <Badge state="error" emphasis="strong" size="small">
          품절
        </Badge>
      )}
    </span>
  );
};
